export default {
  ok: 'ok',
  emailAlreadyExists: 'emailAlreadyExists',
  invalidEmail: 'invalidEmail',
};
